export default {
  notice: 'Notice',
  iUnderstand: 'I understand',
  editOccupyMsg: "You are temporarily unable to edit this post because it is being edited by {name}. You can communicate with {name} to save the edited content as soon as possible, so that you can start editing",
  hideContent: "The content below is only visible to those who comment",
  cantChangeThreadHidden: "The hidden content feature cannot be added or removed from a published thread.",
  hideContentIcon: 'Hide content below',
  showContentIcon: 'Display all content',
  addSticker: 'Stickers',
  selectCover: 'Select Thumbnail',
  hiddenContent: 'Hide Content',
  coverTips: 'New! Choose an image from your thread as a thumbnail!',
  threadCover: 'Thread Thumbnail',
  previewTips: 'This is the thumbnail that will be displayed in the Community.',
  reselectCover: 'Not happy with it? Pick another image from your thread.',
  crop: 'Crop',
  noCover: 'No thumbnail selected',
  noCoverTips: 'You can choose an image from your thread.',
  uploadFail: 'Picture upload failed',
  reUpload: 'Re-upload',
  currentCover: 'Current thumbnail',
  coverCropTips: 'Adjust the image size and focus area to create a better thumbnail.',
  topicNoResult: 'No topics found',
  draftRule: 'This draft will be kept for {draftExpiredTime} days from its creation date. Remember to publish it in time. ',
  draftOverLimit: 'You have exceeded the limit of {draftLimit} drafts. This draft cannot be saved.',
  draftCloseToLimit: 'The draft box can hold a maximum of {draftLimit} drafts. Saving this draft will reach the limit. Please publish some drafts to make space.',
  discard: 'Discard',
  save: 'Save',
  continueEdit: 'Continue editing',
  saveDraft: 'Save as draft?',
  cantSaveDraft: 'Sorry, you cannot save as draft',
  copyError: 'This image cannot be copied currently. Please download and manually upload it instead.'
}